<div *ngIf="isLoading" class="preloader custom-preloader">
    <img src="{{logo}}" width="250">
    <h1 class="text-center m-t-40">Verifying your Account...</h1>
    <!-- <h1 class="text-center">This will only take a moment. Please wait.</h1> -->
    <div class="spinner big-spinner" *ngIf="isLoading">
        <div class="double-bounce1"></div>
        <div class="double-bounce2"></div>
    </div>
</div>


<div *ngIf="status == 1" class="preloader custom-preloader">
    <img src="{{logo}}" width="250">
    <h1 class="text-center m-t-40">Account Activated Successfully.</h1>
    <h3 class="text-center">You have activated your customer account.</h3>
    <h3 class="text-center">Please
        <a class="text-info m-l-5" [routerLink]="['/login']"> <b>click here</b></a> to Sign In your account </h3>
</div>

<div *ngIf="status == 2" class="preloader custom-preloader">
    <img src="{{logo}}" width="250">
    <h1 class="text-center m-t-40">Sorry!</h1>
    <h3 class="text-center">
        {{ message }}
        <h4 class="text-center m-t-20">
            <a class="text-info m-l-5" [routerLink]="['/login']"> <b>Sign In</b></a> in to your already activated account
            <br>
            <p class="m-t-15"> In case you have any concerns, write to us at <a href="mailto:support@dowc.in">support@dowc.com</a> </p>
        </h4>
    </h3>
</div>